export default function OrderTable({ orders = [], renderOrder }) {
  if (!orders.length) return <p className="admin-empty-state">No orders yet.</p>;
  return <div className="admin-record-list">{orders.map((order) => <div key={order._id}>{renderOrder(order)}</div>)}</div>;
}
